import { useCallback, useEffect } from "react";

import { removeCookie } from "@jti/fe-common";

import { adultoCookieKey } from "../../constants";

export function useWidgetAvDataCleanup() {
  const clearWidgetAvData = useCallback(() => {
    removeCookie(adultoCookieKey);
  }, []);

  useEffect(() => {
    return () => {
      clearWidgetAvData();
    };
  }, [clearWidgetAvData]);

  return { clearWidgetAvData };
}
